import React, { Suspense } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { AnimatedContentLoader } from '@components'
import { PermissionBoundary, PermissionSet } from '@context'
import { WorkflowsHub } from './hub/WorkflowsHub'

const WorkflowBuilderPage = React.lazy(() => import('./builder/WorkflowBuilderPage'))

export const WorkflowsPage: React.FC = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <WorkflowsHub />
      </Route>
      <Route path={`${path}/:workflowId`}>
        <PermissionBoundary required={PermissionSet.ADMIN}>
          <Suspense fallback={<AnimatedContentLoader isLoading>{null}</AnimatedContentLoader>}>
            <WorkflowBuilderPage />
          </Suspense>
        </PermissionBoundary>
      </Route>
    </Switch>
  )
}
